export function RemoveButton({
  label,
  onClick
}: {
  label: string
  onClick: () => void
}) {
  return (
    <button
      type='button'
      aria-label={label}
      onClick={onClick}
      className='grid size-9 shrink-0 cursor-pointer place-items-center rounded-md text-ink-muted transition-colors hover:bg-red-50 hover:text-red-700 sm:size-5 dark:hover:bg-red-950/40 dark:hover:text-red-300'
    >
      <svg viewBox='0 0 16 16' className='size-3'>
        <path
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          d='M3 3l10 10M13 3L3 13'
        />
      </svg>
    </button>
  )
}
